module.exports = __webpack_public_path__ + "img/H1.54881ebe.jpg";